// Metric Types
export enum MetricType {
    METRIC_TYPE_TIMER = 'Timer',
    METRIC_TYPE_COUNTER = 'Counter',
    METRIC_TYPE_STRING = 'String',
    METRIC_TYPE_INITIALIZATION = 'Initialization'
}
